import React from 'react';
import { Box } from '@mui/material';
import GroupedPageLines from './GroupedPageLines';

type BoxBorderType = {
  lineWidth?: number;
  pageLineCount?: number;
  firstLineText?: string;
  paddingBottom?: string;
  fontSize?: number;
  marginTopText?: string;
  fontFamily?: string;
  isNarrow?: boolean;
  marginPageLines?: string;
};

const SmallBoxBorderLines = ({
  lineWidth = 325,
  pageLineCount = 1,
  firstLineText,
  paddingBottom,
  fontSize = 39,
  marginTopText,
  fontFamily,
  isNarrow,
  marginPageLines
}: BoxBorderType) => {
  const pageLines = [...Array(pageLineCount).keys()];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        marginTop: 50,
        border: '2px solid #000',
        borderRadius: '25px',
        margin: '0px 10px',
        width: `${lineWidth + 40}px`,
        // width: '80%',
        alignSelf: 'center',
        paddingBottom: paddingBottom
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: isNarrow ? '15px 0px' : '5px 0px'
        }}
      >
        {pageLines.map((x, idx) => {
          const isFirstLine = idx === 0;
          if (isFirstLine && firstLineText) {
            return (
              <GroupedPageLines
                top={20}
                width={lineWidth}
                fontSize={fontSize}
                color="black"
                marginLeftText={3}
                marginTopText={marginTopText}
                fontFamily={fontFamily}
                isNarrow={isNarrow}
              >
                {firstLineText}
              </GroupedPageLines>
            );
          }
          return (
            <GroupedPageLines
              top={20}
              width={lineWidth}
              isNarrow={isNarrow}
              marginPageLines={marginPageLines}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default SmallBoxBorderLines;
